// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Cp5Y","inputWrap":"CustomTip_inputWrap__2K01m"};